<template>
  <div
    class="landing-block"
    :class="{
      shrink: state === STATE_TYPE.SEVENTH,
      lottery: state >= STATE_TYPE.NINTH && state < STATE_TYPE.ELEVENTH,
    }"
  >
    <div class="center" id="landing-block-4">
      <div class="center" id="landing-block-3">
        <div class="center" id="landing-block-2">
          <div class="center" id="landing-block-1">
            <div
              class="content"
              v-if="state === STATE_TYPE.INIT && policy === false"
            >
              <div class="form">
                <p class="title">
                  請填寫您的個人資料<br />
                  本資料將會作為「2021年台灣最佳國際品牌交流會」活動紀錄<br />
                  以及抽獎活動參加者資訊所使用
                </p>
                <p class="subtitle">＊ 所有欄位都必須填寫</p>
                <div
                  class="inputWrap"
                  v-for="(item, index) in form"
                  :key="index"
                  :class="[item.label]"
                >
                  <input
                    v-model="item.data"
                    type="text"
                    :id="item.label"
                    :placeholder="item.placeholder"
                    :maxlength="item.max"
                  />
                </div>
                <div class="inputWrap">
                  <input
                    v-model="phone.data"
                    type="text"
                    :id="phone.label"
                    :placeholder="phone.placeholder"
                    v-mask="['####-###-###']"
                  />
                  <input
                    v-model="email.data"
                    type="text"
                    :id="email.label"
                    :placeholder="email.placeholder"
                    :maxlength="email.max"
                  />
                </div>
                <div class="acceptCheck">
                  <input
                    type="checkbox"
                    id="cbox"
                    value="acceptpolicy"
                    v-model="checked"
                  />
                  <label for="cbox" class="btnPointer"></label>我同意<a
                    style="cursor: pointer; text-decoration: underline"
                    @click="policy = true"
                    >隱私權政策</a
                  >
                </div>
                <p>{{ verificationTxt }}</p>
                <div
                  class="submit btnPointer"
                  :class="{ active: checked[0] == 'acceptpolicy' }"
                >
                  <p @click="checkForm">送出資料</p>

                  <p style="cursor: default">請先勾選隱私權政策</p>
                </div>
              </div>
            </div>
            <div
              class="content"
              v-if="state === STATE_TYPE.INIT && policy === true"
            >
              <div class="policy">
                <div class="top">
                  <img
                    src="@/assets/img/pop/btn_back.svg"
                    alt=""
                    @click="policy = false"
                  />
                  <p class="title">
                    「2021年台灣最佳國際品牌交流會」<br />
                    虛擬展間隱私權及網站安全政策同意書
                  </p>
                </div>
                <div class="description">
                  <p>
                    感謝您蒞臨「2021年台灣最佳國際品牌交流會（以下簡稱本活動）」之活動網站（以下簡稱本網站），為了幫助您瞭解本網站如何蒐集、應用及保護您所提供的個人資訊，請您務必詳細閱讀下列資訊：
                  </p>
                  <p>※隱私權政策※</p>
                  <p>
                    1.
                    關於政策適用範圍以下的隱私權政策，適用於您在本網站活動時，所涉及的個人資料蒐集、運用與保護，但不適用於與本網站以外的相關連結網站，也不適用於非本網站所委託或參與管理的人員。
                  </p>
                  <p>2. 關於個人資料之蒐集、處理及利用方式。</p>
                  <ul>
                    <li>
                      本網站將會請您提供公司名稱、職稱、姓名、聯絡電話、電子郵件信箱（e-mail）等個人最新、最真實之資料，以作為「2021年台灣最佳國際品牌交流會」活動紀錄，以及工業局品牌計畫相關活動訊息推廣使用。
                    </li>
                    <li>
                      本次「2021年台灣最佳國際品牌交流會」活動網站將會設有互動小遊戲，完成遊戲關卡即可參與抽獎。待您依照活動辦法完成後，本網站將會自動為您紀錄遊戲成果，並以您提供的個人資料進行抽獎活動。
                    </li>
                    <li>
                      本網站會記錄使用者上站的IP位址、上網時間以及在網站內所瀏覽的網頁等資料，這些資料係供本活動紀錄成果使用，以及作為本活動主辦單位及所屬管理機關內部作網站流量和網路行為調查的總量分析，以利於提升本網站的服務品質，且本網站僅對全體使用者行為總和進行分析，並不會對個別使用者進行分析。
                    </li>
                    <li>
                      本網站有義務保護各使用者隱私，非經您本人同意（或符合以下情況），不會自行修改或刪除任何使用者的個人資料及檔案：
                    </li>
                  </ul>
                  <p>
                    經由合法的途徑。<br />
                    保護或防衛相關使用者的權利或所有權。<br />
                    為保護本網站各相關單位之權益。<br />
                    本網站絕不會任意出售、交換、或出租任何您的個人資料給其他團體、個人或私人企業。但有下列情形者除外：<br />
                    配合司法單位合法的調查。<br />
                    配合相關職權機關依職務需要之調查或使用。<br />
                    基於善意相信揭露為法律需要，或為維護和改進網站服務而用於管理。<br />
                    關於個人應盡之義務<br />
                    若您提供任何錯誤或不實的資料，本網站各相關單位有權拒絕您使用本網站之全部或部分服務。<br />
                    資料之保護(O)<br />
                    本網站主機均設有防火牆、防毒系統等相關的各項資訊安全設備及必要的安全防護措施，加以保護網站及您的個人資料採用嚴格的保護措施，只由經過授權的人員才能接觸您的個人資料，相關處理人員皆簽有保密切結書等書面約定，如有違反保密義務者，將會受到相關的法律處分。<br />
                    如因業務需要而有必要委託本活動主辦單位及相關單位提供服務時，本網站亦會嚴格要求其遵守保密義務，並且採取必要檢查程序以確定其將確實遵守。<br />
                    網站對外的相關連結<br />
                    本網站的網頁提供其他網站的網路連結，您也可經由本網站所提供的連結點選進入其他網站。但該連結網站不適用於本網站的隱私權保護政策，您必須參考該連結網站中的隱私權保護政策。<br />
                    Cookie之使用<br />
                    本網站會在您電腦瀏覽器中寫入並讀取Cookie，若您不願意接受Cookie的寫入，您可在您使用的瀏覽器功能項中設定隱私權等級為高，即可拒絕Cookie的寫入，但可能因此使本網站部分功能無法正常執行。<br />
                  </p>
                  <p>※網站安全政策※</p>
                  <p>
                    任何未經授權而企圖上載或更改本網站所提供的活動資訊或服務的行為，都是嚴厲禁止而且可能觸犯法律。<br />
                    為了網站安全的目的和確保所有使用者都能順利瀏覽及體驗，本網站提供了以下的安全保護措施：<br />
                    裝設防火牆設備，限制特定通訊埠的連結，防止非法入侵，以避免網站遭到非法使用，保障使用者的權益。<br />
                    使用網路入侵偵測系統，監控網路流量，並對有惡意企圖的行為進行阻隔。<br />
                    裝設掃毒軟體，提供使用者安全的網頁瀏覽環境。<br />
                    利用弱點偵測軟體，不定期針對網路系統弱點掃描，並予以補強修正。<br />
                    不定期模擬駭客攻擊，演練發生資訊安全事件時的系統回復程序，提供網站的持續營運。<br />
                    定期進行備份作業。<br />
                    定時依相關作業系統廠商或應用程式廠商的安全維護通知，更新修復程式。<br />
                    <br />
                    若您對本網站的隱私權及網站安全政策有任何意見，歡迎隨時與我們聯絡。<br />
                    本網站之隱私權及網站安全政策將因應需求隨時進行修正，修正後的條款將刊登於本網站上。<br />
                  </p>
                </div>
              </div>
            </div>
            <div v-if="state === STATE_TYPE.SECOND" class="state2">
              <div class="content">
                <p class="title">請選擇一位您喜歡的虛擬角色</p>
                <p class="description">
                  您將會以此角色瀏覽「2021年台灣最佳國際品牌交流會」線上會場<br />（
                  請注意，確認選取後將無法進行更改）
                </p>
                <div class="avatar">
                  <img
                    :src="avatarImg1[chosenAvatar]"
                    :class="{ active: chosenAvatar == 0 }"
                    @click="chosenAvatar = 0"
                  />
                  <img
                    :src="avatarImg2[chosenAvatar]"
                    :class="{ active: chosenAvatar == 1 }"
                    @click="chosenAvatar = 1"
                  />
                  <img
                    :src="avatarImg3[chosenAvatar]"
                    :class="{ active: chosenAvatar == 2 }"
                    @click="chosenAvatar = 2"
                  />
                  <img
                    :src="avatarImg4[chosenAvatar]"
                    :class="{ active: chosenAvatar == 3 }"
                    @click="chosenAvatar = 3"
                  />
                </div>
                <p class="btnPointer" @click="nextStep">確認角色</p>
              </div>
            </div>

            <div v-if="state === STATE_TYPE.THRIRD" class="state3">
              <div class="content">
                <img
                  class="desktop"
                  src="@/assets/img/pop/sceneImg.jpg"
                  alt=""
                />
                <img
                  class="mobile"
                  src="@/assets/img/pop/sceneImg-mob.jpg"
                  alt=""
                />
                <div class="right-content">
                  <div class="text-content">
                    <p class="title">
                      歡迎蒞臨<br />「2021台灣最佳國際品牌交流會」<br />線上會場
                    </p>
                    <p class="description">
                      由經濟部工業局所主辦、台灣經濟研究院執行的｢台灣品牌耀飛計畫｣，歷年來輔導多家台灣企業，累積了豐碩成果。透過一年一度的「台灣最佳國際品牌交流會」，我們能夠一同見證台灣品牌不斷成長的傲然成績。<br />
                      <br />
                      為因應防疫措施以及數位轉型的浪潮，今年的「台灣最佳國際品牌交流會」首度以線上方式舉辦，並全新打造虛擬會場。
                    </p>
                  </div>
                  <p class="btnPointer" @click="nextStep">下一步</p>
                </div>
              </div>
            </div>

            <div v-if="state === STATE_TYPE.FOURTH" class="state4">
              <div class="content">
                <img
                  class="desktop"
                  src="@/assets/img/pop/sceneImg.jpg"
                  alt=""
                />
                <img
                  class="mobile"
                  src="@/assets/img/pop/sceneImg-mob.jpg"
                  alt=""
                />
                <div class="right-content">
                  <div class="text-content">
                    <p class="title">
                      「2021台灣最佳國際品牌交流會」<br />會場介紹
                    </p>
                    <p class="subtitle">以下將為您介紹本次的虛擬會場</p>
                    <p class="description">
                      今年我們以「虛擬宇宙」為概念，希望能讓各位貴賓於這個空間中盡情瀏覽，並認識更多優秀的「台灣最佳國際品牌」。<br />
                      <br />
                      我們以宇宙中的星球代表各個獲選為「台灣最佳國際品牌」的企業，象徵著各位都是在台灣產業發展中不可或缺的耀眼存在。<br />
                      <br />
                      接下來請盡情參觀體驗，稍後我們的活動將於10:00於舞台前正式開始。
                    </p>
                  </div>
                  <p class="btnPointer" @click="nextStep">下一步</p>
                </div>
              </div>
            </div>

            <div v-if="state === STATE_TYPE.FIFTH" class="state5">
              <div class="content">
                <img
                  class="desktop"
                  src="@/assets/img/pop/sceneImg.jpg"
                  alt=""
                />
                <img
                  class="mobile"
                  src="@/assets/img/pop/sceneImg-mob.jpg"
                  alt=""
                />
                <div class="right-content">
                  <div class="text-content">
                    <p class="title">神秘任務：找出隱藏的字母</p>
                    <p class="subtitle">
                      一起玩遊戲拿好禮！<br />
                      為您介紹互動抽獎遊戲參加方式
                    </p>
                    <p class="description">
                      在等待其他貴賓加入的同時，歡迎與我們一起探索「2021台灣最佳國際品牌交流會」虛擬會場，並找出藏於星球中的神秘符號！<br> 
                      <br> 
                      在各個代表著「台灣最佳國際品牌」的星球中，隱藏著「B、R、E、A、K」5個字母，透過點擊不同星球的方式，即可找到藏於其中的字母，再按兩下就可以成功收集。<br> 
                      <br> 
                      只要完整收集5個字母（順序不限），即算完成任務，您將會獲得「互動抽獎遊戲」參加資格，我們將從中抽取多位幸運得獎者，每人可得到一份精美禮品！                    </p>
                    <div>
                      <img
                        style="width: 40%; margin-right: 5%"
                        src="@/assets/img/pop/coin.jpg"
                      />
                      <img style="width: 40%" src="@/assets/img/pop/coin-click.png" />
                    </div>
                  </div>
                  <p class="btnPointer" @click="nextStep">下一步</p>
                </div>
              </div>
            </div>

            <div v-if="state === STATE_TYPE.SIXTH" class="state6">
              <div class="content" id="state6-content">
                <img
                  class="desktop"
                  src="@/assets/img/pop/sceneImg.jpg"
                  alt=""
                />
                <img
                  class="mobile"
                  src="@/assets/img/pop/sceneImg-mob.jpg"
                  alt=""
                />
                <div class="right-content">
                  <div class="text-content" id="state6-text-content">
                    <p class="title">神秘任務：找出隱藏的字母</p>
                    <p class="subtitle">
                      完成指定任務，多樣精美好禮等你來領取！
                    </p>

                    <p class="gift">
                      🔹CROSSPACE可思創品｜純鈦玫瑰金雙層杯
                    </p>
                    <p class="gift">
                      🔹Tartine唐緹｜芒果土鳳梨酥禮盒
                    </p>
                    <p class="gift">
                      🔹VIIDA｜UiU環保便攜吸管、Wasser保溫瓶
                    </p>
                    <p class="gift">
                      🔹丸文｜ 旗魚鬆隨手包
                    </p>
                    <p class="gift">
                      🔹艾瑪絲｜5α捷利爾頭皮淨化液(HC)
                    </p>
                    <p class="gift">
                      🔹菇王｜ 純釀珍饌禮盒<br> (香菇素蠔油/香菇醬油露)
                    </p>
                    <p class="gift">
                      🔹順天堂｜ 順活沛能量凍飲禮盒、<br>順活沛菁亮凍飲禮盒
                    </p>
                    <p class="gift">
                      🔹黃金盾｜ 黃金盾泡泡洗手液、<br>黃金盾抗菌清潔噴劑
                    </p>

                    <a target="_blank" href="https://www.facebook.com/BrandingTaiwanForward/posts/400965878441238">
                      <img
                        style="width: 125px; height: auto; margin: 20px 0px"
                        src="@/assets/img/pop/facebook.png"
                        class="horizental-center"
                      />
                    </a>
                    <p class="subtitle">
                      ※主辦單位將於12/10 (五) 以Email通知中獎者，請務必留意您的信箱。<br>
                      未中獎者，恕不另行通知。<br>
                      再次謝謝您的參與！
                    </p>
                  </div>
                  <p class="btnPointer" @click="nextStep">下一步</p>
                </div>
              </div>
            </div>

            <div v-if="state === STATE_TYPE.SEVENTH" class="state7">
              <div class="content">
                <p class="title">1. 請點擊地面紫色光點進行移動</p>
                <img
                  class="horizental-center"
                  src="@/assets/img/pop/operation.png"
                  alt=""
                />
                <p class="title">2. 趕快開啟音樂，觀賞效果更加分</p>
                <img
                  class="horizental-center"
                  src="@/assets/img/pop/operation-play.png"
                  alt=""
                />
                <p class="btnPointer horizental-center" @click="start">
                  進入展覽
                </p>
              </div>
            </div>

            <div v-if="state === STATE_TYPE.EIGHTH" class="state8">
              <div class="content">
                <p class="title">恭喜您破解神秘任務！</p>
                <p class="description">
                感謝您參加互動抽獎遊戲「神秘任務：找出隱藏的符號」，並順利完成任務！<br />
                我們將於活動後一週內抽獎，主辦單位會以email通知，請留意。<br />
                再次謝謝您的參與！
                </p>
                <p class="btnPointer horizental-center" @click="close">確定</p>
              </div>
            </div>

            <div v-if="state === STATE_TYPE.NINTH" class="state9">
              <div class="content">
                <p class="title">
                  「2021台灣最佳國際品牌交流會」<br />將於一分鐘後開始
                </p>
                <p class="subtitle">
                  接下來我們將會邀請各位貴賓一同前往舞台前方參與<br />
                </p>
                <p class="btnPointer horizental-center" @click="moveToStage">
                  前往直播
                </p>
              </div>
            </div>

            <div v-if="state === STATE_TYPE.TENTH" class="state10">
              <div class="content">
                <p class="title">
                  每家品牌的表現都太精彩了！<br />
                  繼續完成任務吧，豐富獎品等你喔<br />
                  點擊頭像下方臉書看更多資訊<br />
                  期待明年再次與大家相聚<br />
                </p>

                <p class="btnPointer horizental-center" @click="moveTo25">
                  回到展場
                </p>
              </div>
            </div>

            <div v-if="state === STATE_TYPE.ELEVENTH" class="state11">
              <div class="content">
                <p class="description">
                  <ul>
                    <li>若發現網站載入時間過長，請確認連線速度是否穩定。建議連線速度為 20mps 以上。</li>
                    <li>若讀取網站內容時，發生顯示異常，請確認劉覽器是否停用 Javascript 功能。若是，請啟用 Javascript 功能並重新整理網頁。</li>
                    <li>建議桌上型/筆記型電腦，螢幕解析度設為 1920 x 1080 像素，內容縮放為 100%</li>
                    <li>為維持良好的使用體驗，桌上型/筆記型電腦建議使用滑鼠操作。</li>
                  </ul>
                </p>

                <p class="btnPointer horizental-center" @click="closeFAQ">
                  回到展場
                </p>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div class="dotWrap" v-if="state < 6">
      <div
        v-for="(item, index) in 6"
        :key="'dot' + index"
        :class="{ active: state == index, enable: state > 1 && index > 1 }"
        @click="clickDot(index)"
      ></div>
    </div>
  </div>
</template>

<script>
import { mask } from "vue-the-mask";
import axios from "axios";
export default {
  directives: { mask },
  data() {
    return {
      STATE_TYPE: Object.freeze({
        INIT: 0,
        SECOND: 1,
        THRIRD: 2,
        FOURTH: 3,
        FIFTH: 4,
        SIXTH: 5,
        SEVENTH: 6,
        EIGHTH: 7,
        NINTH: 8,
        TENTH: 9,
        ELEVENTH: 10,
      }),

      form: [
        {
          data: "",
          label: "company_name",
          placeholder: "公司名稱",
          max: 30,
        },
        {
          data: "",
          label: "job_title",
          placeholder: "職稱",
          max: 30,
        },
        {
          data: "",
          label: "name",
          placeholder: "姓名",
          max: 30,
        },
      ],
      phone: {
        data: "",
        label: "contact_number",
        placeholder: "聯絡電話",
      },
      email: {
        data: "",
        label: "email",
        placeholder: "電子郵件email",
        max: 80,
      },
      avatarImg1: [
        `${require(`@/assets/img/role/p1-active.png`)}`,
        `${require(`@/assets/img/role/p1.png`)}`,
        `${require(`@/assets/img/role/p1.png`)}`,
        `${require(`@/assets/img/role/p1.png`)}`,
      ],
      avatarImg2: [
        `${require(`@/assets/img/role/p2.png`)}`,
        `${require(`@/assets/img/role/p2-active.png`)}`,
        `${require(`@/assets/img/role/p2.png`)}`,
        `${require(`@/assets/img/role/p2.png`)}`,
      ],
      avatarImg3: [
        `${require(`@/assets/img/role/p3.png`)}`,
        `${require(`@/assets/img/role/p3.png`)}`,
        `${require(`@/assets/img/role/p3-active.png`)}`,
        `${require(`@/assets/img/role/p3.png`)}`,
      ],
      avatarImg4: [
        `${require(`@/assets/img/role/p4.png`)}`,
        `${require(`@/assets/img/role/p4.png`)}`,
        `${require(`@/assets/img/role/p4.png`)}`,
        `${require(`@/assets/img/role/p4-active.png`)}`,
      ],
      chosenAvatar: 0,
      checked: [],
      policy: false,
      verificationTxt: "",
      state6TextContentEventListener: null,
      state6ContentEventListener: null,
    };
  },
  props: {
    state: {
      type: Number,
      default: 0,
    },
    avatar: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    isMobile() {
      return screen.width < 768;
    },
  },
  methods: {
    checkForm: function (event) {
      var em =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (
        this.form[0].data === "" ||
        this.form[1].data === "" ||
        this.form[2].data === "" ||
        this.phone.data === "" ||
        this.email.data === ""
      ) {
        this.verificationTxt = "您還有資料沒填寫！";
      } else if(this.phone.data.length != 12) {
        this.verificationTxt = "手機格式不正確！";
      } else if (!em.test(this.email.data)) {
        this.verificationTxt = "Email格式不正確！";
      } else {
        let clickTime = new Date();
      
        if (localStorage.getItem("clickTime") === null) {
          this.nextStep();
          localStorage.setItem("clickTime", clickTime.getTime());
          console.log("click!");
        } else {
          if(clickTime.getTime() - parseInt(localStorage.getItem("clickTime")) > 1000 * 10){
            this.nextStep();
            localStorage.setItem("clickTime", clickTime.getTime());
            console.log("click again!");
          } else {
            console.log("wait!");
          }
        }
      }
    },
    setScrollListener: function (active) {
      const vm = this;

      if (active) {
        let scrollHeight = window.document.getElementById(
          "state6-text-content"
        ).scrollHeight;
        let scrollTop = window.document.getElementById(
          "state6-text-content"
        ).scrollTop;

        this.state6TextContentEventListener = window.document
          .getElementById("state6-text-content")
          .addEventListener("scroll", (e) => {
            scrollHeight = window.document.getElementById(
              "state6-text-content"
            ).scrollHeight;
            scrollTop = window.document.getElementById(
              "state6-text-content"
            ).scrollTop;

            if (scrollHeight - scrollTop <= 600) {
              vm.$emit("setDialogIndex", 5);
            } else {
              vm.$emit("setDialogIndex", 4);
            }
          });
        this.state6ContentEventListener = window.document
          .getElementById("state6-content")
          .addEventListener("scroll", (e) => {
            scrollHeight =
              window.document.getElementById("state6-content").scrollHeight;
            scrollTop =
              window.document.getElementById("state6-content").scrollTop;

            if (scrollHeight - scrollTop <= 600) {
              vm.$emit("setDialogIndex", 5);
            } else {
              vm.$emit("setDialogIndex", 4);
            }
          });
      } else {
        window.document
          .getElementById("state6-text-content")
          .removeEventListener("scroll", this.state6TextContentEventListener);
        window.document
          .getElementById("state6-content")
          .removeEventListener("scroll", this.state6ContentEventListener);
      }
    },
    nextStep() {
      const vm = this;

      if (this.state == 0) {
        this.$emit("setName", this.form[2].data);
        localStorage.setItem("usrName", this.form[2].data);

        const bodyFormData = {
          company_name: this.$getRsaCode(this.form[0].data),
          job_title: this.$getRsaCode(this.form[1].data),
          name: this.$getRsaCode(this.form[2].data),
          contact_number: this.$getRsaCode(this.phone.data),
          email: this.$getRsaCode(this.email.data),
        };

        axios({
          method: "post",
          url: `https://btgb-2021-web-app.azurewebsites.net/user`,
          data: bodyFormData,
        })
          .then((res) => {
            console.log(res);
            localStorage.setItem("userid", res.data.data.uuid);
            console.log(res.data.data.uuid);
            this.$emit("next");
          })
          .catch((error) => {
            console.log(error)
            alert("網路回應過長，請確認網路連接正常後重新整理頁面。");
          });
      } else {
        switch (this.state) {
          case 1:
            this.$emit("setAvatar", this.chosenAvatar);
            localStorage.setItem("avatar", this.chosenAvatar);
            this.$emit("setDialogIndex", Math.floor(Math.random() * 3));
            break;
          case 2:
            this.$emit("setDialogIndex", 2);
            break;
          case 3:
            this.$emit("setDialogIndex", 3);
            break;
          case 4:
            this.$emit("setDialogIndex", 4);
            this.$nextTick(() => {
              vm.setScrollListener(true);
            });
            break;
          case 5:
            this.setScrollListener(false);
            this.$emit("setDialogIndex", 6);
            break;
          default:
            this.$emit("setDialogIndex", 0);
            break;
        }
        this.$emit("next");
      }
    },
    start() {
      this.$emit("start");
      this.$emit("setDialogIndex", 7);
    },
    close() {
      this.$emit("closePop");
    },
    closeFAQ() {
      this.$emit("closeFAQ");
    },
    moveToStage() {
      this.$emit("moveToStage");
    },
    moveTo25() {
      this.$emit("moveTo25");
    },
    clickDot(index) {
      if (this.state > 1 && index > 1) {
        this.$emit("clickDot", index);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.center {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.horizental-center {
  position: relative;
  left: 50%;
  transform: translateX(-50%);
}

.vertical-center {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}

.landing-block {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  transition: height .3s, top .3s, transform .3s;

  #landing-block-1 {
    position: absolute;
    box-sizing: border-box;
    border: 1px solid rgba(255, 255, 255, 0.52);
    border-radius: 10px;
    padding: 1.5%;
  }
  #landing-block-2 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.04);
    box-shadow: inset 0px 0px 44px #5a0081;
    border-radius: 15px;
  }
  #landing-block-3 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(16, 16, 16, 0.9);
    border: 1px solid rgba(44, 0, 42, 0.41);
    box-sizing: border-box;
    border-radius: 15px;
  }
  #landing-block-4 {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.04);
    box-shadow: 0px 0px 44px #42005e;
    border-radius: 15px;
  }

  .content {
    position: relative;
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    &::-webkit-scrollbar {
      width: 5px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      border: none;
    }
    &::-webkit-scrollbar-thumb {
      -webkit-border-radius: 100px;
      border-radius: 100px;
      // background: #adf3f9;
    }
  }
  p {
    font-style: normal;
    font-weight: bold;
    line-height: 29px;
    letter-spacing: 0.02em;
    color: white;
  }

  p.title,
  p.subtitle,
  p.btnPointer,
  .submit p,
  p.gift {
    text-align: center;
  }
  p.title {
    margin-top: 0px;
  }
  p.subtitle {
    font-size: 16px;
    color: #ea8585;
  }
  p.btnPointer {
    width: 98%;
    height: 50px;
    line-height: 50px;

    /* Linear */
    background: linear-gradient(
      267.88deg,
      rgba(80, 72, 170, 0.9) -3.15%,
      rgba(133, 67, 160, 0.9) 33.58%,
      rgba(216, 79, 79, 0.9) 70.83%,
      rgba(255, 142, 142, 0.9) 95.32%
    );
    border-radius: 32px;
  }
  .form {
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    .title {
      font-size: 18px;
      line-height: 34px;
    }

    .inputWrap {
      width: 100%;

      input {
        width: calc(100% - 20px);
        background: rgba(255, 255, 255, 0.14);
        line-height: 1.5;
        outline: none;
        border-radius: 50px;
        border: none;
        margin-bottom: 20px;
        color: white;
        -webkit-user-select: default;
        -moz-user-select: default;
      }
    }
    .acceptCheck {
      color: white;
      display: flex;
      align-items: center;
      padding-left: 25px;

      input {
        position: absolute;
        opacity: 0;
        &:checked + label {
          background-color: rgba($color: #b520f3, $alpha: 0.8);
        }
      }

      label {
        display: inline-block;
        position: relative;
        &::before {
          content: "";
          display: inline-block;
          border: 1px solid #fff;
          position: absolute;
          left: -4px;
          top: -4px;
        }
      }
    }
    .submit {
      width: 100%;
      p {
        width: 100%;
        height: 64px;
        line-height: 64px;

        /* Linear */
        background: linear-gradient(
          267.88deg,
          rgba(80, 72, 170, 0.3) -3.15%,
          rgba(133, 67, 160, 0.3) 33.58%,
          rgba(216, 79, 79, 0.3) 70.83%,
          rgba(255, 142, 142, 0.3) 95.32%
        );
        border-radius: 32px;
        cursor: default;

        &:nth-of-type(1) {
          display: none;
        }
      }

      &.active {
        p {
          width: 100%;
          height: 64px;
          line-height: 64px;

          /* Linear */
          background: linear-gradient(
            267.88deg,
            rgba(80, 72, 170, 0.9) -3.15%,
            rgba(133, 67, 160, 0.9) 33.58%,
            rgba(216, 79, 79, 0.9) 70.83%,
            rgba(255, 142, 142, 0.9) 95.32%
          );
          border-radius: 32px;

          &:nth-of-type(1) {
            display: block;
          }
          &:nth-of-type(2) {
            display: none;
          }
        }
      }
    }
  }
  .policy {
    padding: 1% 5%;
    line-height: 31px;
    color: #ffffff;
    .top {
      display: flex;
      .title {
        flex: 1;
        text-decoration-line: underline;
        margin-top: 10px;
      }
    }
    .description p,
    .description li {
      font-weight: normal;
      font-size: 16px;
      line-height: 31px;
      letter-spacing: 0.02em;
    }
  }
  .state2 {
    height: 100%;
    .content {
      width: 100%;
      left: 50%;
      transform: translateX(-50%);
      .description {
        text-align: center;
        font-weight: bold;
      }
      .avatar {
        display: flex;
        align-items: center;
        img {
          height: 100%;
          transition: ease-in-out 0.2s;
          cursor: pointer;
          &.active {
            transform: scale(1.2);
          }
        }
      }
    }
  }

  .state3,
  .state4,
  .state5,
  .state6 {
    height: 100%;
    .content {
      display: flex;
      height: 100%;
      justify-content: space-around;
      align-items: center;
    }
  }
  .state7 {
    width: 100%;
    height: 100%;
    .content {
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
    }
    p:first-of-type {
      margin-bottom: 0;
    }
  }

  .state8,
  .state9,
  .state10,
  .state11 {
    width: 100%;
    height: 100%;

    .content {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 95%;
      height: 80%;
      display: flex;
      transform: translate(-50%, -50%);
      flex-direction: column;
      justify-content: space-evenly;
      padding: 0;
    }
    p.title {
      margin-top: 1em;
      font-size: 18px;
      line-height: 40px;
    }
    p.description {
      font-size: 14px;
      text-align: center;
      padding: 0% 5%;
    }
    p.btnPointer {
      width: 40%;
      height: 40px;
      line-height: 40px;
    }
  }

  .state11 {
    .description {
      margin-top: 0;
    }
    ul {
      margin-block-start: 0px;
      padding-inline-start: 20px;
    }
    li {
      font-size: 16px;
      text-align: left;
      margin: 0px 0px 30px 10px;
    }
  }

  // ------- desktop -------
  @media screen and (min-width: 769px) {
    max-width: 800px;
    min-width: 760px;
    width: 90vw;
    max-height: 560px;
    height: 100vh;

    &.small-size{
      height: calc(100vh - 150px - 60px);
      top: calc(50% + 150px);
      transform: translate(-50%, calc(-50% - 105px));
    }

    &.shrink {
      width: 400px;
      min-width: 400px;
      max-width: 400px;
      height: 60vh;
      min-height: 400px;
      max-height: 450px;
    }
    &.lottery {
      width: 65vw;
      min-width: 350px;
      max-width: 600px;
      height: 45vh;
      min-height: 400px;
      max-height: 420px;
    }

    .desktop {
      display: block;
    }
    .mobile {
      display: none;
    }

    #landing-block-1 {
      width: 97%;
      height: 96%;
    }
    p {
      font-size: 18px;
    }
    .form {
      padding: 4.5% 10.5%;

      .inputWrap input {
        height: 64px;
        font-size: 18px;
        padding-left: 20px;
      }
      .acceptCheck label {
        width: 34px;
        height: 34px;
        margin: 12px 20px 12px 0px;

        &::before {
          width: 40px;
          height: 40px;
        }
      }
    }
    .policy {
      img {
        width: 10%;
      }
      .title {
        font-size: 20px;
        line-height: 36px;
      }
    }
    .state2 {
      .title {
        margin-top: 1em;
        font-size: 20px;
      }
      .description {
        margin: 2% 10% 4% 10%;
        font-size: 16px;
      }
      .avatar {
        justify-content: center;
        margin-bottom: 5%;

        img {
          width: 20%;
          padding: 2%;
          padding-bottom: 0;
        }
      }
      p.btnPointer {
        width: 90%;
        margin-left: 4.5%;
      }
    }
    .state3,
    .state4,
    .state5,
    .state6 {
      .content {
        flex-direction: row;
      }
      img {
        width: 46%;
        height: 92%;
        margin: 5px auto 0px;
        object-fit: cover;
      }
      .right-content {
        width: 46%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .text-content {
          overflow-y: auto;
          height: 100%;
          margin: 2%;
          margin-top: 5%;
          padding-right: 5%;

          .description {
            font-weight: normal;
            font-size: 16px;
          }
        }

        p.btnPointer {
          width: 95%;
        }
      }
    }
    .state6 {
      .subtitle {
        font-size: 15px;
      }
      .gift {
        font-weight: normal;
        font-size: 15px;
        line-height: 25px;
        margin: 10px 0px;
      }
    }
    .state7 {
      p.title {
        margin-top: 1em;
      }
      img {
        width: 40%;
      }
      p.btnPointer {
        width: 50%;
      }
    }
    .state8 {
      .content {
        padding: 2% 5%;
      }
    }
  }

  // ------ mobile ------
  @media screen and (max-width: 768px) {
    max-width: 500px;
    width: 85vw;
    min-height: 350px;
    height: calc(100vh - 150px - 100px);
    position: fixed;
    display: flex;
    align-items: center;
    justify-content: center;

    &.small-size{
      top: 150px;
      transform: translateX(-50%);
    }

    &.shrink {
      width: 70vw;
      min-width: 320px;
      max-width: 500px;
      min-height: 350px;
      max-height: 450px;
      top: calc(50% + 150px);
      transform: translate(-50%, calc(-50% - 75px));

      #landing-block-1 {
        width: 97%;
      }
    }
    &.lottery {
      width: 50vw;
      min-width: 300px;
      max-width: 500px;
      height: 60vh;
      min-height: 200px;
      max-height: 500px;

      #landing-block-1 {
        width: 97%;
      }
    }

    .desktop {
      display: none;
    }
    .mobile {
      display: block;
    }

    #landing-block-1 {
      width: 96%;
      height: 97%;
    }
    p {
      font-size: 14px;
    }
    p.title {
      font-size: 16px;
      line-height: 30px;
      margin-top: 1em;
    }
    p.subtitle {
      font-size: 12px;
    }
    p.btnPointer {
      width: 95%;
      margin-left: 1.5%;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
    }
    .form {
      padding: 6.5% 4.5%;
      p.title {
        font-size: 17px;
      }
      p.subtitle {
        margin-top: 0;
      }
      .submit p,
      .submit.active p {
        height: 50px;
        line-height: 50px;
        font-size: 14px;
      }

      .inputWrap input {
        height: 51px;
        font-size: 14px;
        padding-left: 15px;
      }
      .acceptCheck label {
        width: 24px;
        height: 24px;
        margin: 12px 18px 12px 0px;

        &::before {
          width: 30px;
          height: 30px;
        }
      }
    }
    .policy {
      padding: 1% 5%;
      color: #ffffff;
      .top {
        img {
          width: 19%;
          max-width: 70px;
          min-width: 60px;
        }
        .title {
          font-weight: bold;
          line-height: 32px;
          text-decoration-line: underline;
          padding-left: 10px;
        }
      }
      .description p,
      .description li {
        font-weight: normal;
        font-size: 14px;
        line-height: 29px;
        letter-spacing: 0.02em;
      }
    }
    .state2 {
      .description {
        margin: 8% 4%;
        font-size: 13px;
      }
      .avatar {
        flex-wrap: wrap;
        justify-content: space-evenly;
        margin-bottom: 7%;
        img {
          width: 35%;
          padding: 2%;
          max-width: 140px;
        }
      }
      p.btnPointer {
        width: 90%;
        margin-left: 4.5%;
      }
    }
    .state3,
    .state4,
    .state5,
    .state6 {
      .content {
        overflow-y: auto;
        flex-direction: column;
        justify-content: flex-start;
        img {
          object-fit: cover;
          margin-top: 10px;
          width: 92%;
          height: 90%;
        }
        .right-content {
          width: 92%;

          .description {
            font-weight: normal;
          }
        }
        p.btnPointer {
          width: 98%;
          margin-left: 0.5%;
        }
      }
    }

    .state6 {
      .gift {
        font-size: 12px;
        text-align: center;
        margin: 10px 0px;
      }
    }
    .state7 {
      img {
        width: 40%;
      }
      p.btnPointer {
        width: 50%;
      }
    }
    .state11 {
      .content {
        justify-content: flex-start;
      }
    }
  }
  @media screen and (max-width: 321px) {
    width: 90vw;

    #landing-block-1 {
      width: 95%;
      height: 97%;
    }
    .form .inputWrap input {
      height: 51px;
      font-size: 15px;
      padding-left: 15px;
    }
  }

  ::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: rgba(255, 255, 255, 0.6);
    opacity: 1; /* Firefox */
  }

  :-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: rgba(255, 255, 255, 0.6);
  }

  ::-ms-input-placeholder {
    /* Microsoft Edge */
    color: rgba(255, 255, 255, 0.6);
  }
}
.dotWrap {
  position: absolute;
  bottom: -30px;
  display: flex;
  justify-content: center;
  width: 100%;
  div {
    width: 11px;
    height: 11px;
    background-color: #fff;
    border-radius: 100%;
    margin: 0 5px;
    &.active {
      background-color: #d632f6;
    }
    &.enable {
      cursor: pointer;
    }
  }
}

/* 網頁捲軸【寬度】 */
::-webkit-scrollbar {
  width: 4px;
}
/* 網頁捲軸【背景】顏色 */
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0);
}
/* 網頁捲軸【把手】顏色 */
::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.35);
  border-radius: 20px;
}
/* 網頁捲軸【滑過時】把手的顏色 */
::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.35);
}
</style>
